import Swiper from 'swiper';
import { Navigation, Thumbs } from 'swiper/modules';

const ZOOM_SCALE = 2;

function initMainSlideZoom(slideEl, { onZoomChange } = {}) {
	const noop = { reset() {} };
	const img = slideEl.querySelector(
		'.wp-block-wps-blocks-product-gallery__main-image'
	);
	if (!img) {
		return noop;
	}

	const setZoomed = (zoomed) => {
		slideEl.classList.toggle('is-zoomed', zoomed);
		if (!zoomed) {
			img.style.transform = '';
			img.style.transformOrigin = '';
		}
		onZoomChange?.(zoomed);
	};

	const updateLoupe = (clientX, clientY) => {
		if (!slideEl.classList.contains('is-zoomed')) {
			return;
		}

		const slideRect = slideEl.getBoundingClientRect();
		const originX =
			((clientX - slideRect.left) / slideRect.width) * 100;
		const originY =
			((clientY - slideRect.top) / slideRect.height) * 100;

		img.style.transformOrigin = `${originX}% ${originY}%`;
		img.style.transform = `scale(${ZOOM_SCALE})`;
	};

	const toggleZoom = (clientX, clientY) => {
		const zoomed = !slideEl.classList.contains('is-zoomed');
		setZoomed(zoomed);
		if (zoomed) {
			updateLoupe(clientX, clientY);
		}
	};

	slideEl.addEventListener('click', (e) => {
		toggleZoom(e.clientX, e.clientY);
		e.stopPropagation();
	});

	slideEl.addEventListener('mousemove', (e) => {
		updateLoupe(e.clientX, e.clientY);
	});

	slideEl.addEventListener(
		'touchmove',
		(e) => {
			if (!slideEl.classList.contains('is-zoomed') || e.touches.length !== 1) {
				return;
			}
			e.preventDefault();
			const touch = e.touches[0];
			updateLoupe(touch.clientX, touch.clientY);
		},
		{ passive: false }
	);

	return {
		reset() {
			setZoomed(false);
		},
	};
}

function initProductGallery(blockRoot) {
	const galleryId = blockRoot.dataset.galleryId;
	if (!galleryId || galleryId === '' || blockRoot.dataset.galleryReady === '1') {
		return;
	}

	const mainEl = blockRoot.querySelector(`[data-gallery-main="${galleryId}"]`);
	const thumbsEl = blockRoot.querySelector(`[data-gallery-thumbs="${galleryId}"]`);

	if (!mainEl || !thumbsEl) {
		return;
	}

	const prevEl = blockRoot.querySelector(`[data-gallery-thumb-prev="${galleryId}"]`);
	const nextEl = blockRoot.querySelector(`[data-gallery-thumb-next="${galleryId}"]`);

	const parentEl = mainEl.parentElement;
	const pinIntegerWidth = () => {
		mainEl.style.width = '';
		const rect = parentEl.getBoundingClientRect();
		mainEl.style.width = `${Math.floor(rect.width)}px`;
	};

	pinIntegerWidth();
	if (parentEl) {
		const ro = new ResizeObserver(() => pinIntegerWidth());
		ro.observe(parentEl);
	}

	const thumbsSwiper = new Swiper(thumbsEl, {
		direction: 'vertical',
		slidesPerView: 3,
		spaceBetween: 10,
		watchSlidesProgress: true,
		slideToClickedSlide: true,
		allowTouchMove: true,
	});

	const zoomControllers = [];

	const mainSwiper = new Swiper(mainEl, {
		modules: [Navigation, Thumbs],
		slidesPerView: 1,
		spaceBetween: 0,
		allowTouchMove: true,
		grabCursor: false,
		navigation: {
			prevEl,
			nextEl,
		},
		thumbs: {
			swiper: thumbsSwiper,
		},
	});

	mainEl
		.querySelectorAll('.wp-block-wps-blocks-product-gallery__main-slide')
		.forEach((slideEl) => {
			zoomControllers.push(
				initMainSlideZoom(slideEl, {
					onZoomChange(zoomed) {
						mainSwiper.allowTouchMove = !zoomed;
					},
				})
			);
		});

	mainSwiper.on('slideChangeTransitionStart', () => {
		zoomControllers.forEach((controller) => controller.reset());
		mainSwiper.allowTouchMove = true;
	});

	blockRoot.dataset.galleryReady = '1';
}

function initSingleImageZoom(blockRoot) {
	const slideEl = blockRoot.querySelector(
		'.wp-block-wps-blocks-product-gallery__single'
	);
	if (!slideEl) {
		return;
	}

	initMainSlideZoom(slideEl);
}

document.addEventListener('DOMContentLoaded', () => {
	document
		.querySelectorAll('.wp-block-wps-blocks-product-gallery[data-gallery-id]')
		.forEach((blockRoot) => initProductGallery(blockRoot));

	document
		.querySelectorAll(
			'.wp-block-wps-blocks-product-gallery.is-single-image'
		)
		.forEach((blockRoot) => initSingleImageZoom(blockRoot));
});
